import { UIOutlineTag } from 'features/UI'
import { useMemo } from 'react'
import { isDefined } from 'utils'
import { formatDurationFromMinutes } from '../../Metric.model'

export function MetricTimelineItemReadingTime({ readingTime }: { readingTime?: number }) {
  const readingTimeInMin = useMemo(() => {
    const minutes = formatDurationFromMinutes(readingTime || 0)
    return minutes || '0s'
  }, [readingTime])

  if (!isDefined(readingTime)) {
    return null
  }

  return <UIOutlineTag>{readingTimeInMin} read</UIOutlineTag>
}
